import React from "react";
import { Formik, Form, FieldArray } from "formik";
import { useTranslation } from "react-i18next";
import { FormikFormGroup, FormikInput, Icon, ModalSubmit } from "components/common";
import { Modal, Row, Col, Button, Alert } from "components/bootstrap";
import useRepositories from "./hooks/useRepositories";
import useRepositoryFormErrors from "./hooks/useRepositoryFormErrors";
const KNOWN_FIELDS = ["name", "uri", "path", "load_defaults"];
const CONF_KEY_SAMPLE = "conf.<key>";
const HadoopStorageRepositoryModalForm = ({ hideModal }) => {
  const { t } = useTranslation("enterprise_data_tiering");
  const { onCreateRepository } = useRepositories();
  const { formError, clearFormError, applyBackendErrors } = useRepositoryFormErrors(KNOWN_FIELDS);
  const handleSubmit = (values, { setErrors }) => {
    const conf = Object.fromEntries(values.confArray.filter(({ key }) => key).map(({ key, value }) => [key, value]));
    const { confArray: _confArray, ...valuesWithoutConfArray } = values;
    const valuesWithConf = { ...valuesWithoutConfArray, conf };
    clearFormError();
    return onCreateRepository({ type: "hdfs", ...valuesWithConf }).then(() => hideModal()).catch((error) => applyBackendErrors(error, setErrors));
  };
  const initialValues = {
    name: "",
    uri: "",
    path: "",
    load_defaults: true,
    conf: {},
    confArray: []
  };
  const validate = (values) => {
    var _a, _b, _c;
    const errors = {};
    if (!((_a = values.name) == null ? void 0 : _a.trim())) errors.name = t("repository_form.name_required");
    if (!((_b = values.uri) == null ? void 0 : _b.trim())) errors.uri = t("hadoop_storage.uri_required");
    if (!((_c = values.path) == null ? void 0 : _c.trim())) errors.path = t("hadoop_storage.path_required");
    return errors;
  };
  return /* @__PURE__ */ React.createElement(
    Formik,
    {
      onSubmit: handleSubmit,
      initialValues,
      validate,
      validateOnMount: true
    },
    ({ isSubmitting, isValidating, isValid, values }) => /* @__PURE__ */ React.createElement(Form, null, /* @__PURE__ */ React.createElement(Modal.Body, null, formError && /* @__PURE__ */ React.createElement(Alert, { bsStyle: "danger" }, formError), /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement(
      FormikFormGroup,
      {
        type: "text",
        label: t("repository_form.name"),
        name: "name",
        help: t("repository_form.name_help"),
        required: true
      }
    ), /* @__PURE__ */ React.createElement(
      FormikFormGroup,
      {
        type: "text",
        label: t("hadoop_storage.uri"),
        name: "uri",
        help: t("hadoop_storage.uri_help"),
        required: true
      }
    ), /* @__PURE__ */ React.createElement(
      FormikFormGroup,
      {
        type: "text",
        label: t("hadoop_storage.path"),
        name: "path",
        help: t("hadoop_storage.path_help"),
        required: true
      }
    ), /* @__PURE__ */ React.createElement(
      FormikFormGroup,
      {
        label: t("hadoop_storage.load_defaults"),
        name: "load_defaults",
        help: t("hadoop_storage.load_defaults_help"),
        type: "checkbox"
      }
    ))), /* @__PURE__ */ React.createElement("br", null), /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement("h5", null, /* @__PURE__ */ React.createElement("b", null, t("hadoop_storage.configuration_properties"))), /* @__PURE__ */ React.createElement(Alert, { bsStyle: "info" }, /* @__PURE__ */ React.createElement("code", null, CONF_KEY_SAMPLE), /* @__PURE__ */ React.createElement("p", null, t("hadoop_storage.conf_description"))), /* @__PURE__ */ React.createElement(FieldArray, { name: "confArray" }, ({ remove, push }) => /* @__PURE__ */ React.createElement("div", null, values.confArray.length > 0 && values.confArray.map((pair, index) => /* @__PURE__ */ React.createElement(Row, { key: pair.id }, /* @__PURE__ */ React.createElement(Col, { md: 5 }, /* @__PURE__ */ React.createElement(
      FormikInput,
      {
        id: `${pair.key}-key`,
        name: `confArray.${index}.key`,
        placeholder: t("hadoop_storage.key_placeholder"),
        type: "text"
      }
    )), /* @__PURE__ */ React.createElement(Col, { md: 5 }, /* @__PURE__ */ React.createElement(
      FormikInput,
      {
        id: `${pair.key}-value`,
        name: `confArray.${index}.value`,
        placeholder: t("hadoop_storage.value_placeholder"),
        type: "text"
      }
    )), /* @__PURE__ */ React.createElement(Col, { md: 1 }, /* @__PURE__ */ React.createElement(Button, { bsStyle: "danger", onClick: () => remove(index) }, /* @__PURE__ */ React.createElement(Icon, { name: "delete" }))))), /* @__PURE__ */ React.createElement(
      Button,
      {
        bsStyle: "primary",
        type: "button",
        onClick: () => push({ id: `newRow-${(/* @__PURE__ */ new Date()).getTime()}`, key: "", value: "" })
      },
      /* @__PURE__ */ React.createElement(Icon, { name: "add" }),
      " ",
      t("hadoop_storage.add_conf_property")
    )))))), /* @__PURE__ */ React.createElement(Modal.Footer, null, /* @__PURE__ */ React.createElement(
      ModalSubmit,
      {
        submitButtonText: t("repository_form.create"),
        submitLoadingText: t("repository_form.creating"),
        onCancel: hideModal,
        disabledSubmit: isValidating || !isValid,
        isSubmitting
      }
    )))
  );
};
export default HadoopStorageRepositoryModalForm;
